import { useCallback, useState } from 'react';
import {
  IconButton,
  IconClose,
  ModalDesktop,
  Stack,
  Text,
} from '@adc/parallax-component-library';

import { useModal } from '~/features/modals/useModal';
import { buildTestId } from '~/utils/buildTestId';

type PrivacyNoticeModalProps = {
  onClose?: () => void;
  testID: string;
};

export const PrivacyNoticeModal = ({
  onClose: onCloseProps,
  testID,
}: PrivacyNoticeModalProps) => {
  const [isOpen, setIsOpen] = useState(true);
  const { closeModal } = useModal();

  const onClose = useCallback(() => {
    closeModal('PrivacyNotice');
    onCloseProps?.();
  }, [closeModal, onCloseProps]);

  return (
    <ModalDesktop
      testID={buildTestId({
        testID,
        suffix: ['privacy', 'notice', 'modal'],
      })}
      isOpen={isOpen}
      icon={
        <IconButton
          testID={buildTestId({
            testID,
            suffix: ['privacy', 'notice', 'close', 'icon'],
          })}
          onPress={() => {
            setIsOpen(false);
            setTimeout(() => {
              onClose();
            }, 500);
          }}
          aria-label="Close Modal"
          variant="tertiary"
          size="XS"
          circle
        >
          <IconClose color="black" />
        </IconButton>
      }
      buttons={[
        {
          label: 'Done',
          variant: 'primary',
          // @ts-expect-error Parallax does not have the correct type for button props
          testID: buildTestId({
            testID,
            suffix: ['privacy', 'notice', 'done', 'button'],
          }),
          onPress: () => {
            setIsOpen(false);
            setTimeout(() => {
              onClose();
            }, 500);
          },
        },
      ]}
      title="Privacy Notice"
    >
      <Stack flexDirection="column" flex={1}>
        <Stack
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          marginBottom="$4"
        >
          <Stack maxHeight={600} width="100%">
            <Text
              color="$text.100"
              testID={buildTestId({
                testID,
                suffix: ['privacy', 'notice', 'content'],
              })}
              type="$bodyBase.default"
            >
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
              </p>
              <p>
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est
                laborum.necessary Simulated body text to make scrolling
                necessary. Lorem ipsum dolor sit amet, consectetur adipiscing
                elit, sed do eiusmod tempor incididunt ut labore et dolore magna
                aliqua. Ut enim ad minim veniam, quis odo consequat.Duis aute
                irure dolor in reprehenderit in voluptate velit esse cillum
                dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt
                mollit anim id est
              </p>
              <p>
                laborum.necessary Simulated body text to make scrolling
                necessary.Duis aute irure dolor in reprehenderit in voluptate
                velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
                sint occaecat cupidatat non proident, sunt i fugiat nulla
                pariatur. Excepteur sint occaecat cupidatat non proident, sunt
                in culpa qui officia deserunt mollit anim id est
                laborum.necessary Simulated body text to make scrolling
                necessary. Lorem ipsum dolor sit amet, consectetur adipiscing
                elit, sed do eiusmod tempor incididunt ut
              </p>
              <p>
                labore et dolore magna aliqua. Ut enim ad minim veniam, quis odo
                consequat.Lorem ipsum Lorem ipsum dolor sit amet, consectetur
                adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis odo
                consequat.Lorem ipsum Lorem ipsum dolor sit amet, consectetur
                adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis odo
                consequat.Lorem ipsum Lorem ipsum dolor sit amet, consectetur
              </p>
              <p>
                adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis odo
                consequat.Lorem ipsum Lorem ipsum dolor sit amet, consectetur
                adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis odo
              </p>
              <p>
                consequat.Lorem ipsum Lorem ipsum dolor sit amet, consectetur
                adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis odo
                consequat.Lorem ipsum Lorem ipsum dolor sit amet, consectetur
                adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis odo
                consequat.Lorem ipsum Lorem ipsum dolor sit amet, consectetur
                adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis odo
                consequat.Lorem ipsum Lorem ipsum dolor sit amet, consectetur
              </p>
              <p>
                {' '}
                adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis odo
                consequat.Lorem ipsum Lorem ipsum dolor sit amet, consectetur
                adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis odo
                consequat.Lorem ipsum Lorem ipsum dolor sit amet, consectetur
                adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis odo
              </p>
              <p>
                consequat.Lorem ipsum Lorem ipsum dolor sit amet, consectetur
                adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis odo
                consequat.Lorem ipsum Lorem ipsum dolor sit amet, consectetur
                adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis odo
                consequat.Lorem ipsum
              </p>
            </Text>
          </Stack>
        </Stack>
      </Stack>
    </ModalDesktop>
  );
};
